import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a5fde4e2-7c05-4d6f-9f85-02b21747978d/artifacts/1jxg5966_grief%20coaching%20logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Dr. Griffin', path: '/about' },
    { name: 'Programs', path: '/programs' },
    { name: 'Speaking', path: '/speaking' },
    { name: 'Contact', path: 'https://griefassessment.agcthefixer.info/contact-724806', external: true },
  ];

  const serviceLinks = [
    { name: 'Foundations Introduction', path: '/programs/foundations-introduction' },
    { name: 'Foundations Course', path: '/programs/foundations-course' },
    { name: 'Workshop Series', path: '/programs/workshop-series' },
    { name: 'Intensive Experience', path: '/programs/intensive' },
    { name: 'Cohort Experience', path: '/programs/cohort' },
  ];

  return (
    <footer className="bg-[#1B365D] text-white" data-testid="main-footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL} 
                alt="Dr. Angelia Griffin Grief Coaching" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-white/70 leading-relaxed mb-6">
              Transforming pain into purpose. Helping high-functioning leaders and communities navigate grief with clarity and renewed meaning.
            </p>
            <p className="font-serif italic text-[#C9A962] text-lg">
              "Turning Pain Into Purpose"
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#C9A962] mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  {link.external ? (
                    <a 
                      href={link.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/70 hover:text-white hover:pl-2 transition-all duration-300"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link 
                      to={link.path}
                      className="text-white/70 hover:text-white hover:pl-2 transition-all duration-300"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#C9A962] mb-6">
              Programs
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-white/70 hover:text-white hover:pl-2 transition-all duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#C9A962] mb-6">
              Get In Touch
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#C9A962] mt-0.5 flex-shrink-0" />
                <a 
                  href="mailto:info@agcthefixer.com" 
                  className="text-white/70 hover:text-white transition-colors"
                >
                  info@agcthefixer.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#C9A962] mt-0.5 flex-shrink-0" />
                <a 
                  href="tel:770-422-4048" 
                  className="text-white/70 hover:text-white transition-colors"
                >
                  (770) 422-4048
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} Dr. Angelia Griffin Grief Coaching. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-sm flex-wrap justify-center">
              <Link
                to="/privacy"
                className="text-white/60 hover:text-white transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </Link>
              <span className="text-white/30">|</span>
              <Link
                to="/terms"
                className="text-white/60 hover:text-white transition-colors"
                data-testid="footer-terms-link"
              >
                Terms of Service
              </Link>
              <span className="text-white/30">|</span>
              <span className="text-white/50">IGMA, Inc. 501(c)(3)</span>
              <span className="text-white/30">|</span>
              <span className="text-white/50">AGC LLC</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
